export default "__VITE_ASSET__547de0ab__"